import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "col-md-4 mb-3" }
const _hoisted_22 = { class: "col-md-12" }
const _hoisted_23 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "ruleSetForm",
        onSubmit: _ctx.addRuleset,
        "validation-schema": _ctx.rulesetSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Code "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "code" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      modelValue: value,
                      "onUpdate:modelValue": handleChange,
                      options: _ctx.ruleSetCodeOptions,
                      label: "label",
                      "track-by": "value",
                      valueProp: "value",
                      placeholder: "Sélectionner le code du jeu de règles"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "code",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Libelle "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "name",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le libelle"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "name",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Description "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "description",
                  as: "textarea",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Description..."
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "description",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type de périmètre ciblé "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "scope_type" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      modelValue: value,
                      "onUpdate:modelValue": handleChange,
                      options: _ctx.scopeTypeOptions,
                      label: "label",
                      "track-by": "value",
                      valueProp: "value",
                      placeholder: "Sélectionner le périmètre"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Priorité d’exécution ", -1)),
              _createVNode(_component_Field, { name: "priority" }, {
                default: _withCtx(({ value, handleChange }) => [
                  _createVNode(_component_Multiselect, {
                    modelValue: value,
                    "onUpdate:modelValue": handleChange,
                    options: _ctx.priorityOptions,
                    label: "label",
                    "track-by": "value",
                    valueProp: "value",
                    placeholder: "Sélectionner la priorité"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Pays ", -1)),
                _createVNode(_component_Field, { name: "pays" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.paysOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le pays" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "pays",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Port ", -1)),
                _createVNode(_component_Field, { name: "port" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.ports,
                      searchable: true,
                      loading: _ctx.loadingPorts,
                      placeholder: "Rechercher (nomPort ou locode)...",
                      label: "label",
                      "track-by": "value",
                      onSearchChange: _ctx.searchPort,
                      "filter-results": false,
                      "min-chars": 2
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "loading", "onSearchChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "port",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date d’entrée en vigueur de ce jeu de règles. ", -1)),
                _createVNode(_component_Field, {
                  name: "effective_from",
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de fin d’application éventuelle. ", -1)),
                _createVNode(_component_Field, {
                  name: "effective_to",
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Activer le jeu de règles ", -1)),
              _createVNode(_component_Field, {
                name: "is_active",
                type: "checkbox",
                class: "form-check-input",
                value: true,
                "unchecked-value": false
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[11] || (_cache[11] = _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit"
                }, " Ajouter la règle ", -1)),
                _createVNode(_component_router_link, {
                  to: "/listeRuleSet",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}